'use client';

import { Place } from '@/types/google-maps.types';

const USER_LOCATION_KEY = 'userLocation';

export const setUserLocationStorage = (data: Place) => {
  localStorage.setItem(USER_LOCATION_KEY, JSON.stringify(data));
};

export const getUserLocationStorage = (): null | Place => {
  try {
    const data = localStorage.getItem(USER_LOCATION_KEY);

    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const removeUserLocationStorage = () => {
  localStorage.removeItem(USER_LOCATION_KEY);
};
